import jQuery from 'jquery';
import * as segmentio from 'rp-analytics';

export default function analyticsPage(traits = {}) {
    let pageTraits = {};

    segmentio.setCommonTraits({
        [segmentio.TRAIT_SITE_SECTION]: 'Results',
        [segmentio.TRAIT_SITE_SUB_SECTION_1]: jQuery('[data-site-sub-section-1]')
            .attr('data-site-sub-section-1'),
        [segmentio.TRAIT_SITE_SUB_SECTION_2]: jQuery('[data-site-sub-section-2]')
            .attr('data-site-sub-section-2'),
    });

    const raceId = jQuery('[data-analytics-race-id]')
        .attr('data-analytics-race-id');
    const raceDate = jQuery('[data-analytics-race-date]')
        .attr('data-analytics-race-date');
    const raceTime = jQuery('[data-analytics-race-time]')
        .attr('data-analytics-race-time');
    const coursename = jQuery('[data-analytics-coursename]')
        .attr('data-analytics-coursename');

    if (raceId) {
        pageTraits[segmentio.TRAIT_RACE_ID] = raceId;
    }

    if (raceDate) {
        pageTraits[segmentio.TRAIT_RACE_DATE] = raceDate;
    }

    if (raceTime) {
        pageTraits[segmentio.TRAIT_RACE_TIME] = raceTime;
    }

    if (coursename) {
        pageTraits[segmentio.TRAIT_RACECOURSE] = coursename;
    }

    pageTraits = jQuery.extend({}, traits, pageTraits);

    const pageName = null; // not used for now
    segmentio.page(pageName, pageTraits, segmentio.page.DEFAULT_OPTIONS);
}



// WEBPACK FOOTER //
// ./src/js/analyticsPage.js